import { RoleEnum } from '../enums/roleEnum';

/**
 * The permissions behind the bulk import pages (fe-guide-admin, bulk import caps §2).
 *
 * `admin.superadmin` and a full Admin pass all of them; AuthService.hasAdminPermission() handles that.
 */
export const BulkImportPermissions = {
  /** Jobs list, details, failure reasons, stats and the report download. */
  JobsView: 'bulkImport.jobs.view',
  /** Read the import limits. */
  SettingsView: 'bulkImport.settings.view',
  /** Save the import limits. */
  SettingsManage: 'bulkImport.settings.manage',
} as const;

// The routes, the sidenav items, the Products page button and the landing redirect all read these,
// so what a SubAdmin can see and what they can open cannot drift apart.

export const BULK_IMPORT_JOBS_ACCESS = {
  roles: [RoleEnum.Admin, RoleEnum.SubAdmin],
  permission: BulkImportPermissions.JobsView,
};

export const BULK_IMPORT_SETTINGS_ACCESS = {
  roles: [RoleEnum.Admin, RoleEnum.SubAdmin],
  permission: BulkImportPermissions.SettingsView,
};
